import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, NavigationEnd, RouterOutlet } from "@angular/router";
import { CommonModule } from "@angular/common";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { HeaderComponent } from "../components/header/header.component";
import { FooterComponent } from "../components/footer/footer.component";
import { GlobalModalComponent } from "../components/shared/global-modal/global-modal.component";
import { GlobalNotificationsComponent } from "../components/shared/global-notifications/global-notifications.component";
import { LoginPromptComponent } from "../components/shared/login-prompt/login-prompt.component";
import { DeepLinkService } from "../services/deep-link.service";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    GlobalModalComponent,
    GlobalNotificationsComponent,
    LoginPromptComponent,
  ],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.css",
})
export class AppComponent implements OnInit, OnDestroy {
  title = "paddle_app_angular";
  showHeaderFooter = false;
  private routerSubscription?: Subscription;

  constructor(
    private router: Router,
    private deepLinkService: DeepLinkService,
  ) {}

  ngOnInit() {
    this.deepLinkService.initialize();

    setTimeout(() => {
      this.checkRoute(this.router.url);
    });
    this.routerSubscription = this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((event) => {
        this.checkRoute(event.url);
      });
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
    this.deepLinkService.removeListeners();
  }

  private checkRoute(url: string) {
    const cleanUrl = url.split("?")[0].split("#")[0];
    const authRoutes = [
      "/login",
      "/register",
      "/logout",
      "/forgot-password",
      "/landing",
    ];
    const employeeRoutes = [
      "/employee-interface",
      "/system-alerts",
      "/manualBook",
      "/fixed-booking",
      "/newRegistrations",
      "/approveMatches",
      "/analytics",
      "/admin/tournaments",
    ];
    const knownRoutes = [
      "/home",
      "/clubs",
      "/landing",
      "/book-a-court",
      "/invite-players",
      "/confirm-match",
      "/confirmation",
      "/search-players",
      "/notification",
      "/match-history",
      "/available-players",
      "/profile",
      "/edit-profile",
      "/logout",
      "/your-match",
      "/employee-interface",
      "/analytics",
      "/court-bookings",
      "/manualBook",
      "/fixed-booking",
      "/match-confirmations",
      "/system-alerts",
      "/rb-rank",
      "/friendships",
      "/club-membership",
      "/my-club",
      "/promotions",
      "/approveMatches",
      "/newRegistrations",
      "/register",
      "/login",
      "/forgot-password",
      "/passwordreset",
      "/privacy",
      "/tournaments",
    ];
    const isKnownRoute =
      cleanUrl === "/" ||
      knownRoutes.some(
        (route) => cleanUrl === route || cleanUrl.startsWith(route + "/"),
      );
    const isAuthRoute = authRoutes.some(
      (route) => cleanUrl === route || cleanUrl.startsWith(route + "/"),
    );
    const isEmployeeRoute = employeeRoutes.some(
      (route) => cleanUrl === route || cleanUrl.startsWith(route + "/"),
    );
    this.showHeaderFooter = isKnownRoute && !isAuthRoute && !isEmployeeRoute;
  }
}
